import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';

class PAUTIsoPageForm extends Form {
	state = {
		data: { isoImage: [] },
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		isoImage: Joi.array().min(1).required().label('ISO Image'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.isoImage);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: 2,
					multiple: true,
					name: 'isoImage',
					accept: 'image/*,application/pdf',
					label: 'Isometric Images',
					sublabel: 'Upload Isometric Images',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default PAUTIsoPageForm;
